import { Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { RequireAdmin, RequireAuth } from './components/RequireAuth';
import { MarketingShell } from './marketing/MarketingShell';
import { HomePage } from './marketing/HomePage';
import { PricingPage } from './marketing/PricingPage';
import { AboutPage } from './marketing/AboutPage';
import { LoginPage } from './marketing/LoginPage';
import { NotFoundPage } from './marketing/NotFoundPage';
import { AdminPage } from './app/admin/AdminPage';
import { AppShell } from './app/AppShell';
import { DashboardPage } from './app/DashboardPage';
import { CoursesPage } from './app/CoursesPage';
import { CourseDetailPage } from './app/CourseDetailPage';
import { PuzzlePage } from './app/study/PuzzlePage';
import { TypingPage } from './app/study/TypingPage';
import { SpeakingPage } from './app/study/SpeakingPage';
import { VocabPage } from './app/VocabPage';
import { VocabReviewPage } from './app/VocabReviewPage';
import { MistakesPage } from './app/MistakesPage';
import { ProfilePage } from './app/ProfilePage';
import { PlanPage } from './app/PlanPage';
import { CreateCoursePage } from './app/CreateCoursePage';
import { InvitePage } from './app/InvitePage';

export function App(): JSX.Element {
  return (
    <ErrorBoundary>
      <Routes>
        <Route element={<MarketingShell />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/login" element={<LoginPage />} />
        </Route>

        <Route path="/app" element={<RequireAuth><AppShell /></RequireAuth>}>
          <Route index element={<DashboardPage />} />
          <Route path="courses" element={<CoursesPage />} />
          <Route path="courses/:courseId" element={<CourseDetailPage />} />
          <Route path="study/puzzle/:lessonId" element={<PuzzlePage />} />
          <Route path="study/typing/:lessonId" element={<TypingPage />} />
          <Route path="study/speaking/:lessonId" element={<SpeakingPage />} />
          <Route path="vocab" element={<VocabPage />} />
          <Route path="vocab/review" element={<VocabReviewPage />} />
          <Route path="mistakes" element={<MistakesPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="plan" element={<PlanPage />} />
          <Route path="create" element={<CreateCoursePage />} />
          <Route path="invite" element={<InvitePage />} />
          <Route path="admin" element={<RequireAdmin><AdminPage /></RequireAdmin>} />
        </Route>

        {/* Catch-all 404 — must be last. */}
        <Route element={<MarketingShell />}>
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}
